export default function initJsonFormRenderer(hiddenInput) {
    cleanRenderer(hiddenInput);

    const container = document.createElement('div');
    container.classList.add('json-form-container', 'mb-3');
    hiddenInput.insertAdjacentElement('afterend', container);

    const config = JSON.parse(hiddenInput.dataset.config || '[]');
    let valueArray = [];
    let internalUpdate = false;
    let observer = null;

    // 🔧 Hilfsfunktion zur Platzhalter-Ersetzung
    function replacePlaceholders(template, entry) {
        if (typeof template !== 'string') return template;
        return template.replace(/{{\s*([\w.-]+)\s*}}/g, (_, key) => {
            const val = entry?.[key];
            return val != null ? String(val) : '';
        });
    }

    function renderForm() {
        if (internalUpdate) return;
        container.innerHTML = '';

        try {
            valueArray = JSON.parse(hiddenInput.value || '[]');
        } catch {
            container.innerHTML = '<div class="text-danger">⚠️ Ungültiges JSON im Value</div>';
            return;
        }

        if (!Array.isArray(valueArray)) {
            container.innerHTML = '<div class="text-danger">⚠️ Erwartet ein Array von Objekten</div>';
            return;
        }

        valueArray.forEach((entry, index) => {
            const block = document.createElement('div');
            block.classList.add('border', 'p-3', 'mb-3', 'rounded');

            config.forEach((field) => {
                if (!(field.name in entry) && field.type !== 'static') return;

                const group = document.createElement('div');
                group.classList.add('mb-3');

                switch (field.type) {
                    case 'static': {
                        // Platzhalter im statischen Content ersetzen
                        const html = replacePlaceholders(field.content || '', entry);
                        group.innerHTML = html;
                        break;
                    }

                    case 'input': {
                        const label = document.createElement('label');
                        label.classList.add('form-label');
                        // Label-Text mit Platzhalter ersetzen
                        label.textContent = replacePlaceholders(field.label || field.name, entry);
                        label.htmlFor = `${hiddenInput.id}_${index}_${field.name}`;

                        const input = document.createElement('input');
                        input.type = field.inputType || 'text';
                        input.classList.add('form-control');
                        input.classList.add('json-form');
                        input.id = `${hiddenInput.id}_${index}_${field.name}`;
                        input.name = field.name;
                        input.value = entry[field.name] ?? '';
                        input.addEventListener('input', () => {
                            entry[field.name] = input.value;
                        });

                        group.appendChild(label);
                        group.appendChild(input);
                        break;
                    }

                    case 'checkbox': {
                        const id = `${hiddenInput.id}_${index}_${field.name}`;
                        const divCheck = document.createElement('div');
                        divCheck.classList.add('form-check');

                        const checkbox = document.createElement('input');
                        checkbox.type = 'checkbox';
                        checkbox.classList.add('form-check-input');
                        checkbox.classList.add('json-form');
                        checkbox.id = id;
                        checkbox.name = field.name;
                        checkbox.checked = !!entry[field.name];

                        checkbox.addEventListener('change', () => {
                            entry[field.name] = checkbox.checked;
                        });

                        const label = document.createElement('label');
                        label.classList.add('form-check-label');
                        label.htmlFor = id;
                        label.textContent = replacePlaceholders(field.label || field.name, entry);

                        divCheck.appendChild(checkbox);
                        divCheck.appendChild(label);
                        group.appendChild(divCheck);
                        break;
                    }

                    case 'hidden': {
                        const hiddenEl = document.createElement('input');
                        hiddenEl.type = 'hidden';
                        hiddenEl.name = field.name;
                        hiddenEl.classList.add('json-form');
                        hiddenEl.value = entry[field.name] ?? '';
                        hiddenEl.addEventListener('change', () => {
                            entry[field.name] = hiddenEl.value;
                        });
                        group.appendChild(hiddenEl);
                        break;
                    }
                }

                block.appendChild(group);
            });

            container.appendChild(block);
        });
    }

    function writeBack() {
        internalUpdate = true;
        hiddenInput.value = JSON.stringify(valueArray, null, 2);
        internalUpdate = false;
    }

    observer = new MutationObserver(() => {
        if (!internalUpdate) renderForm();
    });
    observer.observe(hiddenInput, { attributes: true, attributeFilter: ['value'] });

    renderForm();

    hiddenInput._jsonRenderer = { container, observer, writeBack, valueArray };
}

function cleanRenderer(hiddenInput) {
    const existing = hiddenInput._jsonRenderer;
    if (existing) {
        if (existing.observer) existing.observer.disconnect();
        if (existing.container?.parentNode)
            existing.container.parentNode.removeChild(existing.container);
        delete hiddenInput._jsonRenderer;
    }
}

window.updateJsonForms = function() {
    document.querySelectorAll('.json-form-renderer').forEach(hiddenInput => {
        const r = hiddenInput._jsonRenderer;
        if (r && typeof r.writeBack === 'function') r.writeBack();
    });
};